import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="pages--index"
export default class extends Controller {
  static values = {
    redirect: String
  }

  connect() {
    Turbo.visit(this.redirectValue, { action: "advance" })
  }
}
